// extracted by mini-css-extract-plugin
module.exports = {"loading":"_2C4QbwNqE6Jw4wz7v6CMAI"};